import "./home.css";
import { NavLink } from 'react-router-dom';
import React, { useState, useRef, useEffect } from "react";
// import { TweenLite, Power3 } from "gsap";
import leftArrow from "../images/arrow-left.svg";
import rightArrow from "../images/arrow-right.svg";
import tote1 from "../images/tote-1.png";
import tote2 from "../images/tote-6.png";
import straw from "../images/straw.jpeg";
import Footer from "../components/Footer"
import Hero from "../components/Hero"

const Home = () => {

  return (

    <>

    <Hero />
    
    <div className="mt-40 pt-16 pb-80 sm:pt-24 sm:pb-40 lg:pt-40 lg:pb-48">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 sm:static">
        <div className="sm:max-w-lg">
                <h1 className="text-green-400 text-3xl font font-extrabold tracking-tight text-gray-900 sm:text-6xl">
                  About Us
                </h1>
        </div>

        <div className="">
                <h2 className="mt-10 text-xl font tracking-tight text-gray-900 sm:text-3xl">
                We are a part of the Local Leaders of the 21st Century club of Amador Valley High School, a club that strives to improve the environmental state of our community while teaching students leadership skills that will help them in the future.
                </h2>
        </div>

        <div className="">
                <h2 className="mt-10 text-xl font tracking-tight text-gray-900 sm:text-3xl">
                The Sustainability Shop is a student-run shop that works to promote an environmentally-friendly lifestyle. We sell tote bags and t-shirts made with sustainable material and environmentally-conscious messages. We are a part of the Amador Valley Local Leaders of the 21st century, and all profits go towards funding our projects to make our community more sustainable! [+ keep the socials/contact us]
                </h2>
        </div>

        <div className="">
                <h2 className="mt-5 text-xl font tracking-tight text-gray-900 sm:text-3xl">
                Follow our Social Media Pages!
                </h2>
                <h2 className="mt-5 text-xl font tracking-tight text-gray-900 sm:text-3xl">
                Sustainability Shop Instagram: avhs.sus.shop
                </h2>
                <h2 className="mt-5 text-xl font tracking-tight text-gray-900 sm:text-3xl">
                Local Leaders Instagram: avlocaleaders
                </h2>
                <h2 className="mt-5 text-xl font tracking-tight text-gray-900 sm:text-3xl">
                Facebook: LocalLeaders21
                </h2>
                <h2 className="mt-5 text-xl font tracking-tight text-gray-900 sm:text-3xl">
                Email: amadorlocalleaders@gmail.com
                </h2>
        </div>


        {/* <h1 className="text-xl font-bold">About Us</h1>
        <h2 className="font-semibold">
          We are a part of the Local Leaders of the 21st Century club of Amador Valley High School, a club that strives to improve the environmental state of our community while teaching students leadership skills that will help them in the future.
          <div>
            <br></br>
            <br></br>
          </div>

          <div>
            <br></br>
            <br></br>
            <br></br>
          </div>
          
          <div>
            <br></br>
            You can contact us here:
            <br></br>
          </div>
        </h2> */}
      </div>
    </div>
    {/* <Footer /> */}
    </>
    
  );
};

export default Home;